import { BREAKPOINT_CHANGED, INIT_ROOT } from '../actionTypes';

export default (state, { type, payload }) => {
  if (type === INIT_ROOT) {
    return payload.breakpoint;
  }
  if (type === BREAKPOINT_CHANGED) {
    return payload;
  }
  return state || '';
};
